var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.166 6.678H.834V2.93c0-.233.184-.416.417-.416h2.083v1.232c0 .233.184.416.417.416a.412.412 0 00.417-.416V2.515h11.666v1.232c0 .233.184.416.417.416a.412.412 0 00.416-.416V2.515h2.084c.233 0 .416.183.416.416v3.747zm0 12.073a.412.412 0 01-.416.416H1.25a.412.412 0 01-.417-.416V7.511h18.333v11.24zm-.416-17.07h-2.083V.417a.418.418 0 00-.834 0v1.266H4.167V.416a.418.418 0 00-.834 0v1.266H1.25C.558 1.682 0 2.24 0 2.93v15.82C0 19.442.558 20 1.25 20h17.5c.692 0 1.25-.558 1.25-1.249V2.931c0-.691-.558-1.25-1.25-1.25z",
    fill: "#000"
  })));
}
SvgFill.displayName = 'Fill';
export default SvgFill;